import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Equipment } from "../../app/models/equipment";
import { Signaltag } from "../../app/models/OPTag";
import { LdsClientService } from "../lds-client/lds-client.service";
import { StarmsClientProvider } from "../starms-client/starms-client";

export interface OPConfig {
  operationalProfile: Signaltag[];
  dataSource: string;
  timezone: string;
}

@Injectable()
export class OpServiceService {
  public trainHasLiveData = new BehaviorSubject<boolean>(false);

  constructor(
    private starms: StarmsClientProvider,
    private lds: LdsClientService
  ) {}

  fetchConfig(trainId: number) {
    return new Observable<OPConfig>((subscriber) => {
      // Get starms tags
      forkJoin(
        this.starms
          .get(["signals/signaltags/trains", trainId])
          .pipe(
            map((response: any[]) =>
              response.map((entry) => new Signaltag().deserialize(entry))
            )
          ),
        this.starms.get(["trains", trainId, "signaloperations"])
      ).subscribe(
        ([tags, opTags]) => {
          const operationalProfile = tags
            .map((tagEntry) => {
              const index = opTags.findIndex(
                (entry) => entry.tagId === tagEntry.tagId
              );
              if (index > -1) {
                tagEntry.operationalProfile = {
                  definition: (opTags[index] as any).definition,
                };
              }
              if (
                tagEntry.tagId === 5032953 ||
                tagEntry.tagId === 5073995 ||
                tagEntry.tagId === 5033194
              ) {
                tagEntry.operationalProfile = {
                  definition: tagEntry.tagDescription,
                };
              }
              return tagEntry;
            })
            .filter((tagEntry) => tagEntry.operationalProfile);
          forkJoin(
            this.lds.getDataSources(),
            this.starms.get(["equipment", "trains", trainId]).pipe(
              map((rawEq: any[]) => {
                return rawEq
                  .map((entry) => new Equipment().deserialize(entry))
                  .map((entry) => "Data." + entry.getLdsUniqueId());
              })
            )
          ).subscribe(
            ([ldsSources, equipment]) => {
              if (ldsSources.length && equipment.length) {
                this.trainHasLiveData.next(true);
                const trainLDSDataSources = equipment.filter(
                  (entry) => (ldsSources as string[]).indexOf(entry) !== -1
                );
                if (trainLDSDataSources.length) {
                  const ldsTrainSource = trainLDSDataSources[0];
                  forkJoin(
                    this.lds.getTagsList(ldsTrainSource),
                    this.lds.getTimeZone(ldsTrainSource, 1)
                  ).subscribe(
                    ([ldsTags, timeZone]) => {
                      for (const tag of tags) {
                        tag.timeZone = timeZone.zoneId;

                        const ldsTagIndex = ldsTags.entries.findIndex(
                          (entry) => entry.tag === tag.tagName
                        );
                        if (ldsTagIndex > -1) {
                          tag.ldsMeta = ldsTags.entries[ldsTagIndex];
                        }
                      }
                      subscriber.next({
                        operationalProfile: operationalProfile,
                        timezone: timeZone.zoneId,
                        dataSource: ldsTrainSource,
                      });
                      subscriber.complete();
                    },
                    (error) => {
                      subscriber.next({
                        operationalProfile: operationalProfile,
                        timezone: null,
                        dataSource: null,
                      });
                      subscriber.complete();
                    }
                  );
                } else {
                  subscriber.next({
                    operationalProfile: operationalProfile,
                    timezone: null,
                    dataSource: null,
                  });
                  subscriber.complete();
                }
              } else {
                subscriber.next({
                  operationalProfile: operationalProfile,
                  timezone: null,
                  dataSource: null,
                });
                subscriber.complete();
              }
            },
            (error) => {
              subscriber.next({
                operationalProfile: operationalProfile,
                timezone: null,
                dataSource: null,
              });
              subscriber.complete();
            }
          );
        },
        (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/lds-client/op-service.service.ts